export const strings = {
  /**
   * Rendered as a Tag sharing the same locator id as the customer's real
   * tags and always ahead of them, driven by the customer's `doNotService`
   * flag rather than by a tag. A tenant may also define a real tag with this
   * exact name, so this badge cannot be identified by its label alone.
   */
  doNotServiceTag: 'Do Not Service',
} as const;
